<div class="chat-panel-total">
  <div class="chat-panel-history" id="chat-history-panel">
    <!-- Collapse Menu and New Topic buttons -->
    <div class="header-actions m-b-12 p-t-8 p-l-4">
      <button href="javascript:void(0)" (click)="onCloseHistory()"
        class="panel-collapse-btn hover-effect-text t-right t-no-arrow" id="chat-history-collapse-button"
        [attr.data-tooltip]="'CHAT_HISTORY_PANEL_COLLAPSE_MENU_TOOL_TIP' | translate"
        [attr.aria-label]="'CHAT_HISTORY_PANEL_COLLAPSE_MENU_TOOL_TIP' | translate">
        <img src="../../../assets/images/newchat/icon-toggle-button.svg" alt="Collapse">
          {{'CHAT_HISTORY_PANEL_COLLAPSE_MENU_BUTTON' | translate}}
      </button>

      <button (click)="NewTopic(true)" class="btn-new-topic t-right t-no-arrow" id="new-topic-button" [attr.data-tooltip]="'CHAT_HISTORY_PANEL_NEW_TOPIC_BUTTON' | translate" [attr.aria-label]="'CHAT_HISTORY_PANEL_NEW_TOPIC_BUTTON' | translate">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1162_4151)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.9351 1.06488C14.182 0.311706 12.9608 0.311706 12.2076 1.06488L6.57939 6.69313C6.50686 6.76565 6.45839 6.85875 6.44056 6.95978L6.00761 9.4131C5.97926 9.57378 6.03109 9.73818 6.14646 9.85355C6.26184 9.96893 6.42624 10.0208 6.58691 9.9924L9.04024 9.55945C9.14126 9.54163 9.23436 9.49315 9.30689 9.4206L14.9351 3.79238C15.6883 3.0392 15.6883 1.81806 14.9351 1.06488ZM12.9147 1.77199C13.2774 1.40934 13.8654 1.40934 14.228 1.77199C14.5907 2.13464 14.5907 2.72263 14.228 3.08528L8.71124 8.60205L7.11654 8.88348L7.39796 7.28878L12.9147 1.77199Z"
              fill="black" />
            <path
              d="M12.5 8V14C12.5 14.2761 12.2761 14.5 12 14.5H2C1.72386 14.5 1.5 14.2761 1.5 14V4C1.5 3.72385 1.72386 3.5 2 3.5H8C8.27615 3.5 8.5 3.27615 8.5 3C8.5 2.72385 8.27615 2.5 8 2.5H2C1.17157 2.5 0.5 3.17158 0.5 4V14C0.5 14.8284 1.17157 15.5 2 15.5H12C12.8284 15.5 13.5 14.8284 13.5 14V8C13.5 7.72385 13.2761 7.5 13 7.5C12.7239 7.5 12.5 7.72385 12.5 8Z"
              fill="black" />
          </g>
          <defs>
            <clipPath id="clip0_1162_4151">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {{ "CHAT_HISTORY_PANEL_NEW_TOPIC_BUTTON" | translate }}
      </button>
    </div>
    <div class="agent-selector-wrapper">
      <hr class="divider-line m-b-4" *ngIf="availableAgents.length > 0"/>
      <app-agent-selector *ngIf="availableAgents.length > 0"
      [availableAgents]="availableAgents" 
      [currentAgentId]="currentAgentId" 
      (agentSelected)="handleAgentSelection($event)"></app-agent-selector>
    </div>
    <!-- Horizontal line -->
    <hr class="divider-line m-b-4" />
    
    <!-- Chatbot Mode: Show conversation history with filter -->
    <div *ngIf="isAgentMode === false" class="chat-conversation-header p-0">
      <div class="header-content">
        <div class="header-content-title black-400 font-subheading1-sm p-l-0">
          {{'CHAT_HISTORY_PANEL_CONVERSATION_HISTORY_TEXT' | translate}} ({{getConversationHistoryCount()}})
        </div>
        <!-- Filter Dropdown -->
        <div class="time-filter">
          <button class="days-dropdown" (click)="toggleFilterDropdown()" [disabled]="isAnyDatasetLoading()">
            <img src="../../../assets/images/newchat/icon-filter.svg" alt="Filter" title="{{'FILTER_TOOLTIP_TEXT' | translate}}">
            {{
              selectedFilter === '7 Days' ? ('DAYS_FILTER_TEXT_7_DAYS' | translate) :
              selectedFilter === '15 Days' ? ('DAYS_FILTER_TEXT_15_DAYS' | translate) :
              selectedFilter === '30 Days' ? ('DAYS_FILTER_TEXT_30_DAYS' | translate) :
              (selectedFilter | translate)
            }}
            <i class="fa-solid fa-chevron-down"></i>
          </button>
          <div class="filter-dropdown" *ngIf="showFilterDropdown" #dropdown>
            <button (click)="setFilter('7 Days')" [disabled]="isAnyDatasetLoading()">{{'DAYS_FILTER_TEXT_7_DAYS' | translate}}</button>
            <button (click)="setFilter('15 Days')" [disabled]="isAnyDatasetLoading()">{{'DAYS_FILTER_TEXT_15_DAYS' | translate}}</button>
            <button (click)="setFilter('30 Days')" [disabled]="isAnyDatasetLoading()">{{'DAYS_FILTER_TEXT_30_DAYS' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Chatbot Mode: Show tabs and sessions -->
    <div class="chat-tabs-container" *ngIf="isAgentMode === false">
      <div class="chat-tabs">
        <button *ngFor="let dataset of tabList" (click)="selectTab(dataset)" class="hover-effect-text"
          [class.active-tab]="selectedTab === dataset">
          {{ dataset === 'All' ? ('CHAT_HISTORY_PANEL_ALL_TAG' | translate) : (dataset | translate) }}
        </button>
      </div>
    </div>

    <!-- "All" Tab: Show all datasets with expandable sections -->
    <div *ngIf="isAgentMode === false">
      <div *ngIf="selectedTab === 'All'" class="chat-sessions-all">
        <div *ngFor="let dataset of vectorDbDatasets" class="dataset-section">
        <div class="dataset-header hover-effect-bg" (click)="toggleDataset(dataset.name)">
          <span class="dataset-icon">📂</span>
          <span class="dataset-name">{{ dataset.name | translate}}<span *ngIf="isDatasetApiTriggered(dataset.name) && moduleThreadsCounts[dataset.name.toLowerCase()] > 0"> ({{moduleThreadsCounts[dataset.name.toLowerCase()] || 0}})</span></span>
          <span class="toggle-icon">
            <i [class]="expandedDatasets[dataset.name] ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
          </span>
        </div>
        <div *ngIf="expandedDatasets[dataset.name]" class="dataset-sessions scrollable-folder"
          [attr.data-dataset]="dataset.name" (scroll)="onFolderScroll($event, dataset.name)">
          
          <!-- Initial Loading State for Dataset (only when no sessions exist) -->
          <div *ngIf="isDatasetInitialLoading(dataset.name)" class="dataset-no-data">
            <div class="dataset-no-data-content">
              <span class="dataset-no-data-text">{{'LOADING_SESSION_TEXT' | translate}}</span>
            </div>
          </div>

          <!-- No Data State for Empty Dataset -->
          <div *ngIf="!isDatasetLoading(dataset.name) && getGroupedSessions()[dataset.name]?.length === 0" class="dataset-no-data">
            <div class="dataset-no-data-content">
              <span class="dataset-no-data-text">{{'NO_CHAT_SESSIONS_FOUND_SUGGESTION' | translate}}</span>
            </div>
          </div>

          <!-- Sessions List (always show if sessions exist, even during lazy loading) -->
          <ng-container *ngIf="!isDatasetInitialLoading(dataset.name)">
            <div *ngFor="let item of getGroupedSessions()[dataset.name]; let i = index"
              class="list-view list-view-arrows">
            <div class="list-view-inner p-l-20 m-b-0" [ngClass]="{'chat-active': item.is_selected}">
              <div class="list-view-chatname-input">
                <div class="list-view-chatname flex-container-row" (click)="onSelectSession(item)">
                  <span title="{{item.chat_name}}">
                    {{item.chat_name}}
                  </span>
                  <div class="text-right chat-history-icons" id="chat-history-menu-icons">
                    <button class="t-left t-no-arrow" [attr.data-tooltip]="'EDIT_RENAME_DROPDOWN_MENU_TOOLTIP' | translate" (click)="positionChatMenu(item, $event)" id="chat-history-menu-icon">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </button>
                  </div>
                </div>

                <div [ngClass]="{'show': item.dropdownVisible}" class="chat-history-menu">
                  <button title="{{'EDIT_RENAME_DROPDOWN_RENAME_BUTTON_TOOLTIP' | translate}}" (click)="renameSession(item, $event)"
                    class="chat-history-rename-delete hover-effect-bg">
                    <i class="icon-edit-3 p-r-5"></i> {{'EDIT_RENAME_DROPDOWN_RENAME_BUTTON_TEXT' | translate}}
                  </button>
                  <button title="{{'EDIT_RENAME_DROPDOWN_SHARE_BUTTON_TEXT' | translate}}" (click)="shareSession(item, $event)"
                    class="chat-history-rename-delete hover-effect-bg">
                    <img src="../../../assets/images/icon-share.svg" alt="Share" class="share-icon"> {{'EDIT_RENAME_DROPDOWN_SHARE_BUTTON_TEXT' | translate}}
                  </button>
                  <button title="{{'EDIT_RENAME_DROPDOWN_DELETE_BUTTON_TEXT' | translate}}" (click)="confirmDelete(item, $event)"
                    class="chat-history-rename-delete hover-effect-bg">
                    <i class="icon-trash-2 p-r-5"></i> {{'EDIT_RENAME_DROPDOWN_DELETE_BUTTON_TEXT' | translate}}
                  </button>
                </div>
              </div>
            </div>
            </div>
            
            <!-- Lazy Loading Indicator (show at bottom when loading more sessions) -->
            <div *ngIf="isDatasetLazyLoading(dataset.name)" class="lazy-loading-indicator">
              <div class="lazy-loading-content">
                <div class="lazy-loading-spinner"></div>
                <span class="lazy-loading-text">{{'LOADING_MORE_SESSIONS_TEXT' | translate}}</span>
              </div>
            </div>
          </ng-container>
        </div>
        </div>
      </div>

      <!-- Individual Dataset Tabs: Show only the selected dataset -->
      <div *ngIf="selectedTab !== 'All'">
      <!-- Initial Loading State for Selected Tab (only when no sessions exist) -->
      <div *ngIf="isDatasetInitialLoading(selectedTab)" class="chat-sessions__no-results" role="status" aria-live="polite">
        <div class="chat-sessions__no-results-content">
          <!-- Loading State Icon -->
          <div class="chat-sessions__no-results-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" opacity="0.3" />
              <path d="M8 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
              <path d="M12 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4" />
            </svg>
          </div>
          <!-- Loading Message -->
          <div class="chat-sessions__no-results-text">
            <p class="chat-sessions__no-results-subtitle">
              {{'LOADING_SESSION_TEXT' | translate}}
            </p>
          </div>
        </div>
      </div>

      <!-- No Data State for Selected Tab -->
      <div *ngIf="!isDatasetLoading(selectedTab) && hasNoDataForSelectedTab()" class="chat-sessions__no-results" role="status" aria-live="polite">
        <div class="chat-sessions__no-results-content">
          <!-- Empty State Icon -->
          <div class="chat-sessions__no-results-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" opacity="0.3" />
              <path d="M8 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.5" />
              <path d="M12 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity="0.4" />
            </svg>
          </div>
          <!-- No Results Message -->
          <div class="chat-sessions__no-results-text">
            <p class="chat-sessions__no-results-subtitle">
              {{'NO_CHAT_SESSIONS_FOUND_FOR_DATASET_SUBTEXT' | translate: { datasetName: selectedTab } }}
              <br>
              <span class="chat-sessions__no-results-suggestion">{{'NO_CHAT_SESSIONS_FOUND_SUGGESTION' | translate}}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Sessions with data (always show if sessions exist, even during lazy loading) -->
      <div *ngIf="!isDatasetInitialLoading(selectedTab) && !hasNoDataForSelectedTab()" class="dataset-sessions scrollable-tab"
        (scroll)="onTabScroll($event, selectedTab)">
        <div *ngFor="let item of getFilteredSessions(); let i = index" class="list-view">
          <div class="list-view-inner" [ngClass]="{'chat-active': item.is_selected}">
            <div class="list-view-chatname-input">
              <div class="list-view-chatname flex-container-row" (click)="onSelectSession(item)">
                <span title="{{item.chat_name}}">
                  {{item.chat_name}}
                </span>
                <div class="text-right chat-history-icons" id="chat-history-menu-icons">
                  <button title="{{'EDIT_RENAME_DROPDOWN_MENU_TOOLTIP' | translate}}" (click)="positionChatMenu(item, $event)" id="chat-history-menu-icon">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                </div>
              </div>

              <div [ngClass]="{'show': item.dropdownVisible}" class="chat-history-menu">
                <button title="{{'EDIT_RENAME_DROPDOWN_RENAME_BUTTON_TOOLTIP' | translate}}" (click)="renameSession(item, $event)"
                  class="chat-history-rename-delete hover-effect-bg">
                  <i class="icon-edit-3 p-r-5"></i> {{'EDIT_RENAME_DROPDOWN_RENAME_BUTTON_TEXT' | translate}}
                </button>
                <button title="{{'EDIT_RENAME_DROPDOWN_SHARE_BUTTON_TEXT' | translate}}" (click)="shareSession(item, $event)"
                  class="chat-history-rename-delete hover-effect-bg">
                  <img src="../../../assets/images/icon-share.svg" alt="Share" class="share-icon"> {{'EDIT_RENAME_DROPDOWN_SHARE_BUTTON_TEXT' | translate}}
                </button>
                <button title="{{'EDIT_RENAME_DROPDOWN_DELETE_BUTTON_TEXT' | translate}}" (click)="confirmDelete(item, $event)"
                  class="chat-history-rename-delete hover-effect-bg">
                  <i class="icon-trash-2 p-r-5"></i> {{'EDIT_RENAME_DROPDOWN_DELETE_BUTTON_TEXT' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Lazy Loading Indicator for Tab View (show at bottom when loading more sessions) -->
        <div *ngIf="isDatasetLazyLoading(selectedTab)" class="lazy-loading-indicator">
          <div class="lazy-loading-content">
            <div class="lazy-loading-spinner"></div>
            <span class="lazy-loading-text">{{'LOADING_MORE_SESSIONS_TEXT' | translate}}</span>
          </div>
        </div>
        </div>
      </div>
    </div>
    
    <!-- Agent Mode: Show session history component -->
    <div *ngIf="isAgentMode === true" class="agent-sessions-wrapper">
      <app-session-history
        #sessionHistory
        [agentId]="currentAgentId"
        [currentSessionId]="getCurrentAgentSessionId()"
        [isResponseStreaming]="IsResponseStreaming"
        (sessionSelected)="onAgentSessionSelected($event)"
        (newChatRequested)="onAgentNewChat()"
        (showDeleteSuccessMessage)="showDeleteSuccessMessage.emit()"
        (showEditSuccessMessage)="showEditSuccessMessage.emit()"
        (showShareSuccessMessage)="showShareSuccessMessage.emit()"
        (showPopupMessage)="showPopupMessage.emit($event)">
      </app-session-history>
    </div>
  </div>
</div>

<!-- Global popup - moved outside all constraining containers -->
<div class="popup-backdrop"
  *ngIf="(selectedItemForAction && (selectedItemForAction.isDeleting || selectedItemForAction.is_edited || selectedItemForAction.is_shared)) 
         || (isAgentMode && sessionHistoryComponent?.selectedItemForAction && (sessionHistoryComponent.selectedItemForAction.isDeleting || sessionHistoryComponent.selectedItemForAction.is_edited || sessionHistoryComponent.selectedItemForAction.is_shared))
         || showSessionSwitchConfirmationPopup 
         || showFilterSwitchConfirmationPopup"
  (click)="$event.stopPropagation()">
  <ng-container *ngIf="selectedItemForAction && selectedItemForAction.isDeleting">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'EDIT_RENAME_DROPDOWN_DELETE_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'EDIT_RENAME_DROPDOWN_DELETE_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="deleteSession(selectedItemForAction)" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelDelete(selectedItemForAction)" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="selectedItemForAction && selectedItemForAction.is_edited">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'EDIT_RENAME_DROPDOWN_RENAME_POPUP_TITLE' | translate}}
          <span class="char-counter" [class.char-counter-limit]="(selectedItemForAction.chat_name?.length || 0) >= 100">{{ selectedItemForAction.chat_name?.length || 0 }}/100</span>
        </h1>
      </div>
      <div class="popup-body">
        <input type="text" [(ngModel)]="selectedItemForAction.chat_name" class="margin-2 margin-top-5" maxlength="100">
        <div *ngIf="!selectedItemForAction.chat_name || selectedItemForAction.chat_name.trim() === ''" class="alert-danger">{{'EDIT_RENAME_POPUP_ALERT_MESSAGE' | translate}}</div>
        <div *ngIf="selectedItemForAction.chat_name && selectedItemForAction.chat_name.length >= 100" class="alert-danger">{{'RENAME_MAX_LENGTH_ERROR' | translate}}</div>
      </div>
      <div class="popup-footer">
        <button (click)="updateSession(selectedItemForAction)" class="button primary">{{'SAVE_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelRename(selectedItemForAction)" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="selectedItemForAction && selectedItemForAction.is_shared">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'EDIT_RENAME_DROPDOWN_SHARE_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <input type="text" [value]="selectedItemForAction.share_link" readonly class="margin-2 margin-top-5" 
               style="background-color: #f5f5f5; cursor: default;">
      </div>
      <div class="popup-footer">
        <button (click)="copyShareLink(selectedItemForAction)" class="button primary">{{'COPY_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelShare(selectedItemForAction)" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
  
  <!-- Agent Mode Popups (driven by child sessionHistory state/methods) -->
  <ng-container *ngIf="isAgentMode && sessionHistoryComponent?.selectedItemForAction && sessionHistoryComponent.selectedItemForAction.isDeleting">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'EDIT_RENAME_DROPDOWN_DELETE_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'EDIT_RENAME_DROPDOWN_DELETE_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="sessionHistoryComponent.deleteSession(sessionHistoryComponent.selectedItemForAction)" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="sessionHistoryComponent.cancelDelete(sessionHistoryComponent.selectedItemForAction)" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isAgentMode && sessionHistoryComponent?.selectedItemForAction && sessionHistoryComponent.selectedItemForAction.is_edited">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'EDIT_RENAME_DROPDOWN_RENAME_POPUP_TITLE_AGENT' | translate}}
          <span class="char-counter" [class.char-counter-limit]="(sessionHistoryComponent.selectedItemForAction.thread_name?.length || 0) >= 100">{{ sessionHistoryComponent.selectedItemForAction.thread_name?.length || 0 }}/100</span>
        </h1>
      </div>
      <div class="popup-body">
        <input type="text" [(ngModel)]="sessionHistoryComponent.selectedItemForAction.thread_name" class="margin-2 margin-top-5" maxlength="100">
        <div *ngIf="!sessionHistoryComponent.selectedItemForAction.thread_name || sessionHistoryComponent.selectedItemForAction.thread_name.trim() === ''" class="alert-danger">{{'EDIT_RENAME_POPUP_ALERT_MESSAGE' | translate}}</div>
        <div *ngIf="sessionHistoryComponent.selectedItemForAction.thread_name && sessionHistoryComponent.selectedItemForAction.thread_name.length >= 100" class="alert-danger">{{'RENAME_MAX_LENGTH_ERROR' | translate}}</div>
      </div>
      <div class="popup-footer">
        <button (click)="sessionHistoryComponent.updateSession(sessionHistoryComponent.selectedItemForAction)" class="button primary">{{'SAVE_BUTTON_TEXT' | translate}}</button>
        <button (click)="sessionHistoryComponent.cancelRename(sessionHistoryComponent.selectedItemForAction)" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isAgentMode && sessionHistoryComponent?.selectedItemForAction && sessionHistoryComponent.selectedItemForAction.is_shared">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'EDIT_RENAME_DROPDOWN_SHARE_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <input type="text" 
               [value]="sessionHistoryComponent.selectedItemForAction.share_link || (sessionHistoryComponent.selectedItemForAction.placeholder ? ('SHARE_LINK_PLACEHOLDER_AGENT' | translate) : '')" 
               readonly 
               class="margin-2 margin-top-5" 
               style="background-color: #f5f5f5; cursor: default;">
      </div>
      <div class="popup-footer">
        <button 
          (click)="sessionHistoryComponent.copyShareLink(sessionHistoryComponent.selectedItemForAction)" 
          class="button primary"
          [disabled]="!sessionHistoryComponent.selectedItemForAction.share_link">
          {{'COPY_BUTTON_TEXT' | translate}}
        </button>
        <button (click)="sessionHistoryComponent.cancelShare(sessionHistoryComponent.selectedItemForAction)" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
  
  <!-- Session Switch While Streaming Confirmation Popup -->
  <ng-container *ngIf="showSessionSwitchConfirmationPopup">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'NEW_CHAT_STREAMING_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'SESSION_SWITCH_STREAMING_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="confirmSwitchSession()" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelSwitchSession()" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>

  <!-- Filter Switch While Streaming Confirmation Popup -->
  <ng-container *ngIf="showFilterSwitchConfirmationPopup">
    <div class="popup">
      <div class="popup-header">
        <h1>{{'NEW_CHAT_STREAMING_POPUP_TITLE' | translate}}</h1>
      </div>
      <div class="popup-body">
        <p>{{'FILTER_SWITCH_STREAMING_POPUP_CONTENT' | translate}}</p>
      </div>
      <div class="popup-footer">
        <button (click)="confirmFilterSwitchWhileStreaming()" class="button primary">{{'CONFIRM_BUTTON_TEXT' | translate}}</button>
        <button (click)="cancelFilterSwitchWhileStreaming()" class="button">{{'CANCEL_BUTTON_TEXT' | translate}}</button>
      </div>
    </div>
  </ng-container>
</div>